import { VersionConfigModel } from "app/health-check/model/health-check.model";
import { HealthCheckService } from "app/health-check/services/health-check.service";
import { CardItemModel } from "common/layout/components/card/model/card.model";
import { SYSTEM_VERSION } from "config";
import i18next from "i18next";
import { useEffect, useState } from "react";
import { Card } from 'common/layout/components/card/Card';
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import en from '../../i18n/en-us.json';
import pt from '../../i18n/pt-br.json';
import es from '../../i18n/es-es.json';



export function VersionHealthCheck() {
	i18next.addResourceBundle('us', 'translation', en);
	i18next.addResourceBundle('br', 'translation', pt);
	i18next.addResourceBundle('es', 'translation', es);

	const { t, i18n } = useTranslation();

    const [versionState, setVersionState] = useState<CardItemModel[]>([]);
    const [versionData, setVersionData] = useState<VersionConfigModel>();

    function buildVersionItems(data: VersionConfigModel | undefined): void {
        let versionArray: CardItemModel[] = [];
        versionArray.push({ title: t('healthCheck.version.frontendVersion'), value: SYSTEM_VERSION });
        versionArray.push({ title: t('healthCheck.version.templateVersion'), value: 'v1.3' });
        if (data) {
            versionArray.push({ title: t('healthCheck.version.backendVersion'), value: data.backendVersion });
            versionArray.push({ title: t('healthCheck.version.agentVersion'), value: data.agentVersion });
        }

        setVersionState(versionArray);
    }

    useEffect(() => {
        (async () => {
            buildVersionItems(versionData);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language, versionData]);

    useEffect(() => {
        (async () => {
            try {
                const versionResponse = await HealthCheckService.getVersionConfig();
                if (versionResponse && !versionResponse.hasErrors) {
                    setVersionData(versionResponse.data);
                }
            } catch (err) {
                toast.error(`${t('crud.read.errorMessage')}`);
            } finally {
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <>
            <Card title={t('healthCheck.version.title')} items={versionState}></Card>
        </>
    );
}